import { useEffect } from "react";
import {
  ContactRequest,
  DefaultApi,
  HTTPValidationError,
} from "../adapters/api";

export const useContact = () => {
  const defaultApi = new DefaultApi();

  const postContactForm = async (
    contactRequest: ContactRequest
  ): Promise<HTTPValidationError> =>
    new Promise((resolve, reject) => {
      defaultApi
        .contact(contactRequest)
        .then((response) => {
          const { data } = response;
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return {
    postContactForm,
  };
};
